import { render, staticRenderFns } from "./GoodsConfirm.vue?vue&type=template&id=b62138b2&scoped=true"
import script from "./GoodsConfirm.vue?vue&type=script&lang=js"
export * from "./GoodsConfirm.vue?vue&type=script&lang=js"
import style0 from "./GoodsConfirm.vue?vue&type=style&index=0&id=b62138b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62138b2",
  null
  
)

export default component.exports